"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wetBathRoomTypes = exports.twinRoomStandardSpecialRequests = exports.twinRoomSpecialRequests = exports.twinRoomImprovedSpecialRequests = exports.roomTypeMapping = exports.loweredBathRoomTypes = exports.isIconForRoomTypes = exports.TWINROOM = exports.ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING = exports.ROOM_TYPE_TO_BATHROOM_MAPPING = exports.ROOM_TYPE = exports.PREMIER_PLUS_ROOM_TYPES = exports.PREMIER_PLUS_ACCESSIBLE = exports.GALLERY_IMAGE_MAPPING = exports.ACCESSIBLE_ROOM_TYPES = exports.ACCESSIBLE_ROOM_TYPE = exports.ACCESSIBLE = void 0;
var ROOM_TYPE = exports.ROOM_TYPE = {
  STANDARD: 'DBLWIN',
  STANDARD_EXTRA: 'EXTDBL',
  STANDARD_BIGGER: 'BIGWIN',
  PREMIER_PLUS: 'PPLDBL',
  PREMIER_PLUS_VIEW: 'VPPDBL',
  FAMILY_TRIPLE: 'FMTRPL',
  FAMILY_THRE: 'FMTHRE',
  FAMILY_QUAD: 'FMQUAD',
  FAMILY_FOUR: 'FMFOUR',
  TRIPLE_SOFA_CHAIR: 'FMTRSC',
  FAMILY_SOFA_BUNK_BED: 'FMTBUNK',
  PREMIER_PLUS_FAMILY: 'PFAMIL',
  TWIN_RM: 'TWINRM',
  TWIN_DOUBLE: 'DBLDBL',
  TWIN_DOUBLE_ZIP_LINK: 'ZPLDBL',
  PDBZPL: 'PDBZPL',
  BRFTWN: 'BRFTWN',
  BRFZPL: 'BRFZPL',
  TWIN_TWO_BEDS: 'twobeds',
  TWIN_DOUBLE_SOFA: 'doublesofa',
  TWIN: 'TWIN',
  DOUBLE: 'DOUBLE',
  SINGLE: 'SINGLE',
  LOWERED_DOUBLE: 'LOWDBL',
  WET_DOUBLE: 'WETDBL',
  LOWERED_TWIN: 'LOWTWN',
  WET_TWIN: 'WETTWN',
  ACCESSIBLE_TWIN: 'ACCWIN',
  LOWERED: 'lowered',
  WET: 'wet',
  PREMIER_PLUS_LOWERED_DOUBLE: 'PPDLOW',
  PREMIER_PLUS_WET_DOUBLE: 'PPDWET'
};
var loweredBathRoomTypes = exports.loweredBathRoomTypes = [ROOM_TYPE.LOWERED_DOUBLE, ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE, ROOM_TYPE.LOWERED_TWIN];
var wetBathRoomTypes = exports.wetBathRoomTypes = [ROOM_TYPE.WET_DOUBLE, ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE, ROOM_TYPE.WET_TWIN];
var roomTypeMapping = exports.roomTypeMapping = {
  'Accessible Double': {
    [ROOM_TYPE.LOWERED]: ROOM_TYPE.LOWERED_DOUBLE,
    [ROOM_TYPE.WET]: ROOM_TYPE.WET_DOUBLE,
    premierPlus: {
      [ROOM_TYPE.LOWERED]: ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE,
      [ROOM_TYPE.WET]: ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE
    }
  },
  'Barrierefreies Doppelzimmer': {
    [ROOM_TYPE.LOWERED]: ROOM_TYPE.LOWERED_DOUBLE,
    [ROOM_TYPE.WET]: ROOM_TYPE.WET_DOUBLE,
    premierPlus: {
      [ROOM_TYPE.LOWERED]: ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE,
      [ROOM_TYPE.WET]: ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE
    }
  },
  'Accessible Twin': {
    [ROOM_TYPE.LOWERED]: ROOM_TYPE.LOWERED_TWIN,
    [ROOM_TYPE.WET]: ROOM_TYPE.WET_TWIN
  },
  'Barrierefreies Zweibettzimmer': {
    [ROOM_TYPE.LOWERED]: ROOM_TYPE.LOWERED_TWIN,
    [ROOM_TYPE.WET]: ROOM_TYPE.WET_TWIN
  }
};
var twinRoomImprovedSpecialRequests = exports.twinRoomImprovedSpecialRequests = ['TW2S'];
var twinRoomStandardSpecialRequests = exports.twinRoomStandardSpecialRequests = ['TWDS'];
var twinRoomSpecialRequests = exports.twinRoomSpecialRequests = [...twinRoomImprovedSpecialRequests, ...twinRoomStandardSpecialRequests];
var PREMIER_PLUS_ROOM_TYPES = exports.PREMIER_PLUS_ROOM_TYPES = [ROOM_TYPE.PREMIER_PLUS, ROOM_TYPE.PDBZPL, ROOM_TYPE.PREMIER_PLUS_FAMILY, ROOM_TYPE.PREMIER_PLUS_VIEW];
var ACCESSIBLE_ROOM_TYPES = exports.ACCESSIBLE_ROOM_TYPES = [ROOM_TYPE.LOWERED_DOUBLE, ROOM_TYPE.WET_DOUBLE, ROOM_TYPE.LOWERED_TWIN, ROOM_TYPE.WET_TWIN, ROOM_TYPE.ACCESSIBLE_TWIN, ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE, ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE];
var ACCESSIBLE_ROOM_TYPE = exports.ACCESSIBLE_ROOM_TYPE = 'DIS';
var ACCESSIBLE = exports.ACCESSIBLE = 'accessible';
var TWINROOM = exports.TWINROOM = 'twinRoom';
var PREMIER_PLUS_ACCESSIBLE = exports.PREMIER_PLUS_ACCESSIBLE = 'premierPlusAccessible';
var isIconForRoomTypes = exports.isIconForRoomTypes = {
  [ACCESSIBLE]: true,
  [PREMIER_PLUS_ACCESSIBLE]: true
};
var GALLERY_IMAGE_MAPPING = exports.GALLERY_IMAGE_MAPPING = [{
  type: ACCESSIBLE,
  images: [{
    pathKey: 'accessible.loweredBath.image.path1',
    titleKey: 'hoteldetails.accessibleLoweredBathroom'
  }, {
    pathKey: 'accessible.wetRoom.image.path2',
    titleKey: 'hoteldetails.accessibleWetRoom'
  }]
}, {
  type: TWINROOM,
  images: [{
    pathKey: 'twinroom.improvedTwin.image.path1',
    titleKey: 'twinroom.improvedTwin.title'
  }, {
    pathKey: 'twinroom.standardTwin.image.path2',
    titleKey: 'twinroom.standardTwin.title'
  }]
}, {
  type: PREMIER_PLUS_ACCESSIBLE,
  images: [{
    pathKey: 'accessible.premierplus.loweredBath.image.path1',
    titleKey: 'hoteldetails.accessibleLoweredBathroom'
  }, {
    pathKey: 'accessible.premierplus.wetRoom.image.path2',
    titleKey: 'hoteldetails.accessibleWetRoom'
  }]
}];
var ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING = exports.ROOM_TYPE_TO_DISPLAY_TEXT_MAPPING = {
  [ROOM_TYPE.DOUBLE]: 'search.roomTypes.double',
  [ROOM_TYPE.SINGLE]: 'hoteldetails.rates.standardroomstitle',
  [ROOM_TYPE.STANDARD]: 'hoteldetails.rates.standardroomstitle',
  [ROOM_TYPE.PREMIER_PLUS]: 'hoteldetails.rates.premierplus',
  [ROOM_TYPE.STANDARD_EXTRA]: 'hoteldetails.standardRoomExtra',
  [ROOM_TYPE.STANDARD_BIGGER]: 'pihotelinfo.hubBiggerRoomTitle',
  [ROOM_TYPE.FAMILY_TRIPLE]: 'search.roomTypes.family',
  [ROOM_TYPE.FAMILY_THRE]: 'search.roomTypes.family',
  [ROOM_TYPE.FAMILY_FOUR]: 'search.roomTypes.family',
  [ROOM_TYPE.FAMILY_QUAD]: 'search.roomTypes.family',
  [ROOM_TYPE.WET_DOUBLE]: 'accessible.double',
  [ROOM_TYPE.LOWERED_DOUBLE]: 'accessible.double',
  [ROOM_TYPE.WET_TWIN]: 'accessible.twin',
  [ROOM_TYPE.LOWERED_TWIN]: 'accessible.twin',
  [ROOM_TYPE.ACCESSIBLE_TWIN]: 'accessible.twin',
  [ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE]: 'accessible.double',
  [ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE]: 'accessible.double',
  [ROOM_TYPE.TWIN_RM]: 'roomrequirements.type.single',
  [ROOM_TYPE.TWIN_DOUBLE]: 'roomrequirements.type.single',
  [ROOM_TYPE.TWIN_DOUBLE_ZIP_LINK]: 'groupBooking.roomRequirements.type.twin.title'
};
var ROOM_TYPE_TO_BATHROOM_MAPPING = exports.ROOM_TYPE_TO_BATHROOM_MAPPING = {
  [ROOM_TYPE.LOWERED_DOUBLE]: {
    loweredKey: 'LOWDBL',
    wetKey: 'WETDBL'
  },
  [ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE]: {
    loweredKey: 'LOWDBL',
    wetKey: 'WETDBL'
  },
  [ROOM_TYPE.LOWERED_TWIN]: {
    loweredKey: 'LOWTWN',
    wetKey: 'WETTWN'
  },
  [ROOM_TYPE.WET_DOUBLE]: {
    loweredKey: 'LOWDBL',
    wetKey: 'WETDBL'
  },
  [ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE]: {
    loweredKey: 'LOWDBL',
    wetKey: 'WETDBL'
  },
  [ROOM_TYPE.WET_TWIN]: {
    loweredKey: 'LOWTWN',
    wetKey: 'WETTWN'
  }
};